import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=2b96ebaa&scoped=true&"
import script from "./EmployeeDetails.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetails.vue?vue&type=style&index=0&id=2b96ebaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96ebaa",
  null
  
)

export default component.exports